<div class="popup">
    {$showMessage}

    <CloseButton on:click={() => showMessage.set(false)} />
</div>

<style>
.popup{
    position: absolute;
    max-width: 600px;
    background-color: #afa849;
    padding: 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 30px;
}
</style>

<script>
import { showMessage } from "../stores/index"
import CloseButton from "../components/buttons/Close.svelte"
</script>